/**
 * Analytics — API Pública (legacy compat + factory)
 *
 * Este arquivo mantém compatibilidade com código existente
 * e expõe a nova factory tipada.
 *
 * Novo código deve usar:
 *   import { track, Events } from '@/lib/analytics';
 *   track(Events.whatsappClick({ provider: 'Carol', source: 'passeio-360' }));
 *
 * Código legacy ainda funciona:
 *   import { pageview, event } from '@/lib/analytics';
 */

import { analytics, track } from './analytics-factory';
import { Events } from './analytics-events';
import { config } from './config';

export { analytics, track, Events };
export type { AnalyticsEvent, ProductItem } from './analytics-events';

/* ═══════════════════════════════════════════
   Legacy API — mantida para compatibilidade
   ═══════════════════════════════════════════ */

export function pageview(path: string, title?: string) {
  track(Events.pageView(path, title));
}

export function event(action: string, params?: Record<string, string | number | boolean>) {
  if (typeof window === 'undefined' || !config.ga4Id) return;
  const gtag = (window as any).gtag;
  if (!gtag) return;
  gtag('event', action, params);
}

export function whatsappClick(provider: string, source: string) {
  track(Events.whatsappClick({ provider, source }));
}
